import React, {useEffect} from "react";
import InputCheckbox from "../input-checkbox";
import {useTranslation} from "react-i18next";
import SvgIcon from "../svg-icon";
import SlimSelect from "slim-select";
import ClassWatcher from "../../hooks/ClassWatcher";

const MobileFilter = props => {

    const {
        search,
        onChange,
        searchProvider,
        setSearchProvider,
        providers,
        setProviders,
        providersFiltered,
        handleProviderUpdate,
        setSortByUI
    } = props
    const {t} = useTranslation()

    useEffect(() => {
        new SlimSelect({
            select: '#filter3',
            events: {
                afterChange: newVal => setSortByUI(newVal[0].value)
            },
            settings: {
                showSearch: false,
            }
        });
    }, [])


    useEffect(() => {
        var mfilterBtn = document.querySelector('.filter__btn');
        var mfilterClose = document.querySelector('.mfilter__close');
        var mfilter = document.querySelector('.mfilter');

        function toggleMfilter() {
            mfilter.classList?.toggle('mfilter--active');
        }

        mfilterBtn?.addEventListener('click', toggleMfilter);
        mfilterClose?.addEventListener('click', toggleMfilter);

        document?.addEventListener('click', function (event) {
            if (mfilter.classList?.contains('mfilter--active')) {
                var isClickInsideMf = mfilter.contains(event.target);
                var isClickButtonMf = mfilterBtn.contains(event.target) || mfilterClose.contains(event.target);

                if (!isClickInsideMf && !isClickButtonMf) {
                    mfilter.classList?.remove('mfilter--active');
                }
            }
        });
    }, [])

    const handleClose = () => {
        var mfilter = document.querySelector('.mfilter');
        mfilter.classList?.remove('mfilter--active');
    }

    const workOnClassAdd = () => {
        console.log('workOnClassAdd')

        const root = document.getElementById('root')
        root?.classList?.add('no-scroll')
        document.body?.classList?.add('no-scroll')
    }

    const workOnClassRemove = () => {
        console.log('workOnClassRemove')

        const root = document.getElementById('root')
        root?.classList?.remove('no-scroll')
        document.body?.classList?.remove('no-scroll')
    }

    useEffect(() => {
        let targetNode = document.getElementById('mfilter')
        new ClassWatcher(targetNode, 'mfilter--active', workOnClassAdd, workOnClassRemove)
    }, [])

    return (
        <div className="mfilter" id={'mfilter'}>
            <div className="mfilter__head">
                <h6 className="mfilter__title">Filter</h6>

                <button className="mfilter__close" type="button">
                    <SvgIcon id={'x'}/>
                </button>
            </div>

            <div className="mfilter__select-wrap">
                <div className="mfilter__group">
                    <div className="search">
                        <input
                            value={search}
                            name="search"
                            onChange={onChange}
                            type="text" className="search__input"

                            placeholder={t('casino.search', 'Search')}
                            // placeholder="Search"
                        />


                        <button className="search__btn" type="button">
                            <SvgIcon id={'search'}/>
                        </button>
                    </div>
                </div>


                <div className="mfilter__group">
                    <span className="mfilter__label">Filter by</span>
                    <button
                        className="modal__wallet-dropdown-btn gapp2"
                        type="button"
                        id="modalWalet0"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {t('casino.provider')}
                        <SvgIcon id={'right-down'}/>
                    </button>

                    <div className="dropdown-menu modal__wallet-menu"
                         aria-labelledby="modalWalet0">

                        <div className="modal__wallet-search">
                            <div className="search">
                                <input
                                    value={searchProvider}
                                    name="search"

                                    onChange={e => setSearchProvider(e.target.value)}
                                    type="text"
                                    className="search__input"
                                    placeholder={t('casino.search')}
                                />
                                {
                                    providers?.length >= 1 && <button
                                        onClick={e => setProviders([])}
                                        className="trade__change">
                                        <SvgIcon id={'clear'}/>
                                        {/*<span>{t('casino.clear')}</span>*/}
                                    </button>
                                }

                            </div>
                        </div>
                        <ul className="modal__wallet-currencies">
                            {
                                providersFiltered?.map(provider => (
                                    <li key={provider.id} onClick={e => e.stopPropagation()}
                                        className="provider">
                                        <InputCheckbox checked={providers.includes(provider.id)}
                                                       label={provider?.name}
                                                       badge={provider.total}
                                                       onChange={e => handleProviderUpdate(provider.id)}
                                        />
                                    </li>
                                ))
                            }

                        </ul>
                    </div>
                </div>

                <div className="mfilter__group">
                    <span className="mfilter__label">
                        {t('casino.sort-by')}
                    </span>
                    <select name="filter3" id="filter3" className="filter__select">
                        <option value={'a-z'}>{t('casino.a-z')}</option>
                        <option value={'z-a'}>{t('casino.z-a')}</option>
                        <option value={'popular'}>{t('casino.popular')}</option>
                        <option value={'recently-added'}>{t('casino.recently-added')}</option>
                        <option value={'random'}>{t('casino.random')}</option>
                        <option value={'payout'}>{t('casino.payout')}</option>
                        <option value={'max_multiplier'}>{t('casino.max_multiplier')}</option>
                    </select>
                </div>
            </div>

            <button
                onClick={handleClose}
                className="mfilter__apply" type="button">
                {t('casino.apply')}
            </button>
        </div>
    )


}

export default MobileFilter
